import { SimpleTruncatedTooltipText } from '@elliemae/ds-truncated-tooltip-text';
import React from 'react';
import { LEFT_NAVIGATION_DATA_TESTID } from '../../constants/index.js';
import { ItemRenderer } from '../../exported-related/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';
import { StyledDate, StyledLabel, StyledRightContainer } from '../styled.js';

export const ItemWithDate = (props: DSLeftNavigationT.ComponentProps): JSX.Element => {
  const {
    item,
    item: {
      itemOpts: {
        label,
        RightComponent,
        labelRightSection,
        labelOverflow: itemLabelOverflow,
        labelBold,
        labelColor,
        labelDataTestId,
      },
    },
    ctx,
    ctx: {
      leftNavProps,
      leftNavProps: { labelOverflow: leftNavLabelOverflow },
    },
  } = props;
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);

  const labelOverflow = itemLabelOverflow || leftNavLabelOverflow;
  return (
    <ItemRenderer
      item={{
        ...item,
        CollapsedComponent: null,
      }}
      minHeight="32px"
      paddingTop="8px"
    >
      {/* Empty LeftComponent */} <div />
      <StyledLabel
        pl="xxs"
        pb="xxxs"
        labelOverflow={labelOverflow}
        labelBold={labelBold}
        labelColor={labelColor}
        data-testid={labelDataTestId || LEFT_NAVIGATION_DATA_TESTID.LIST_ITEM_LABEL_ID_EXCEPTION}
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        {labelOverflow === 'truncate' && label ? (
          <SimpleTruncatedTooltipText value={label} placement="bottom-start" />
        ) : (
          label
        )}
      </StyledLabel>
      <StyledRightContainer
        pr="xxs2"
        cols={['auto', 'auto']}
        alignItems="center"
        gutter="xxs"
        data-testid={LEFT_NAVIGATION_DATA_TESTID.RIGHT_CONTAINER} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        <StyledDate
          ml="xxs"
          data-testid={LEFT_NAVIGATION_DATA_TESTID.ITEM_DATE} // https://jira.elliemae.io/browse/PUI-15589
          getOwnerProps={getOwnerProps}
          getOwnerPropsArguments={getOwnerPropsArguments}
        >
          {labelRightSection}
        </StyledDate>
        {RightComponent && <RightComponent ctx={ctx} item={item} />}
      </StyledRightContainer>
    </ItemRenderer>
  );
};
